import { render, staticRenderFns } from "./ViewBarStudio.vue?vue&type=template&id=d2af3956"
import script from "./ViewBarStudio.vue?vue&type=script&lang=js"
export * from "./ViewBarStudio.vue?vue&type=script&lang=js"
import style0 from "./ViewBarStudio.vue?vue&type=style&index=0&id=d2af3956&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports